import { Record } from 'immutable';

export default class CustomerAgreementInvoiceSetting extends Record({
  id: undefined,
  addAddressReferenceRow: undefined,
  addAgreementReferenceRow: undefined,
  addCustomerRow: undefined,
  addDateRangeRow: undefined,
  addExternalOrderNumber: undefined,
  addResourceRow: undefined,
  addServiceRow: undefined,
  addWorkTypeAndTimeCodeRow: undefined,
  customer: undefined,
  groupRowsBy: undefined,
  useArticles: undefined,
  includeDate: undefined,
  includeResource: undefined,
  includeService: undefined,
  includeTime: undefined,
  includeTimeReports: undefined,
  includeWeek: undefined,
  includeWorkTypeAndTimeCode: undefined,
  invoiceDeliveryType: undefined,
  invoiceReferenceType: undefined,
  paymentTerms: undefined,
  recipientType: undefined,
  splitOnResource: undefined,
  splitOnCustomer: undefined,
  splitDeviations: undefined,
  useRounding: undefined,
}) {
}

